import React from 'react';
import { PageHeader } from '@components/page-header';
import TenantOverview from './tenant-overview';
import CollectedStartReport from './collected-stars';
import LicensesExport from './licenses-export';

const Reports = () => (
    <>
        <PageHeader title="Reports" />
        <div className="grid gap-4 md:grid-cols-2">
            <TenantOverview />
            <CollectedStartReport />
            <LicensesExport />
        </div>
    </>
);

export default Reports;
